export default __webpack_public_path__ + "static/media/wilson.7f2a53ae.png";